import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/cotizaciones/nueva", "documento": "quotation", "acceso": "sesion", "filas": ["088"], "cita": "Areas/Quotation/Controllers/QuotationController.cs"} satisfies RutaProd;
